// extracted by mini-css-extract-plugin
export default {"column__text":"styles_column__text__IaKYp","pagination__wrapper":"styles_pagination__wrapper__mYF1p","pagination__container":"styles_pagination__container__daZNP"};